import { PartnerGroupRules, UserGroupRules } from 'src/graphql/entities/group-rules';
import { PartnerSetting } from 'src/graphql/entities/partner-setting';
import { EntityNames } from 'src/graphql/types';

export interface EntityRulesData {
  allowedRules?: (PartnerGroupRules | UserGroupRules)[];
  disallowedPartnerSettings?: PartnerSetting[];
}

export const RULES_MAP_PER_VIEW_ENTITY: Record<EntityNames, EntityRulesData> = {
  [EntityNames.Conversation]: {
    allowedRules: [UserGroupRules.AccessToViewConversations],
  },
  [EntityNames.Project]: {
    allowedRules: [PartnerGroupRules.AccessToProvisionProjects],
    disallowedPartnerSettings: [PartnerSetting.DisabledProvisionProjects],
  },
  [EntityNames.Client]: {},
  [EntityNames.Site]: {},
  [EntityNames.PlatformUser]: {},
};
